(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.header = document.querySelector('.shopify-section-header');
			this.headerWrapper = document.querySelector('.header-wrapper');
			this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
			this.headerBounds = {};
			this.currentScrollTop = 0;
			this.preventReveal = false;

			// Only enable scroll behavior if not always sticky
			if (!this.headerIsAlwaysSticky && this.getAttribute('data-sticky-type') === 'on-scroll-up') {
				this.onScrollHandler = this.onScroll.bind(this);
				this.hideHeaderOnScrollUp = () => this.preventReveal = true;

				this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
				window.addEventListener('scroll', this.onScrollHandler, false);

				this.createObserver();
			}
		}

		disableScroll() {
			if (this.onScrollHandler) {
				window.removeEventListener('scroll', this.onScrollHandler);
			}
		}

		enableScroll() {
			if (this.onScrollHandler) {
				window.addEventListener('scroll', this.onScrollHandler, false);
			}
		}

		disconnectedCallback() {
			if (this.hideHeaderOnScrollUp && this.onScrollHandler) {
				this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
				window.removeEventListener('scroll', this.onScrollHandler);
			}
		}

		createObserver() {
			try {
				let observer = new IntersectionObserver((entries, observer) => {
					if (entries[0] && entries[0].intersectionRect) {
						this.headerBounds = entries[0].intersectionRect;
					}
					observer.disconnect();
				});

				if (this.header) {
					observer.observe(this.header);
				}
			} catch (error) {
				console.warn('IntersectionObserver not supported');
			}
		}

		onScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

			// Simplified scroll logic
			if (scrollTop > this.currentScrollTop && scrollTop > (this.headerBounds.bottom || 100)) {
				// Scrolling down
				this.hide();
			} else if (scrollTop < this.currentScrollTop && scrollTop > (this.headerBounds.bottom || 100)) {
				// Scrolling up
				if (!this.preventReveal) {
					this.reveal();
				} else {
					window.clearTimeout(this.isScrolling);
					this.isScrolling = setTimeout(() => {
						this.preventReveal = false;
					}, 66);
					this.hide();
				}
			} else if (scrollTop <= (this.headerBounds.top || 0)) {
				// At top
				this.reset();
			}

			this.currentScrollTop = scrollTop;
		}

		hide() {
			if (this.header) {
				this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
				this.closeMenuDisclosure();
			}
		}

		reveal() {
			if (this.header) {
				this.header.classList.add('shopify-section-header-sticky');
				this.header.classList.remove('shopify-section-header-hidden');
			}
		}

		reset() {
			if (this.header) {
				this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky');
			}
		}

		closeMenuDisclosure() {
			try {
				this.disclosures = this.disclosures || this.header?.querySelectorAll('details-disclosure') || [];
				this.disclosures.forEach((disclosure) => {
					if (disclosure && typeof disclosure.close === 'function') {
						disclosure.close();
					}
				});
				
				this.disclosureLists = this.header?.querySelectorAll('.disclosure__list') || [];
				this.disclosureLists.forEach((disclosureList) => {
					if (disclosureList) {
						disclosureList.setAttribute('hidden', true);
					}
				});
			} catch (error) {
				console.warn('Error closing menu disclosures:', error);
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')) {
        activeMedia.loadContent();
      }
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
